import { map } from 'rxjs/operators';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy, inject } from '@angular/core';
import { TrialBannerService } from '@app/shell/trial-banner/service/trial-banner.service';
import { Subscription, tap } from 'rxjs';

@Component({
    selector: 'app-leaderboard-trial-invites-info',
    templateUrl: './leaderboard-trial-invites-info.component.html',
    styleUrls: ['./leaderboard-trial-invites-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LeaderboardTrialInvitesInfoComponent implements OnInit, OnDestroy {
    private readonly trialBannerService = inject(TrialBannerService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    height: string;
    invitesTrial$ = this.trialBannerService.invitesTrial$;
    invitesSent$ = this.invitesTrial$.pipe(map((data) => data.sent));
    invitesMax$ = this.invitesTrial$.pipe(map((data) => data.max));

    private readonly subscriptions$ = new Subscription();

    get sendedAnyInvite() {
        return this.trialBannerService.invitesTrial.sent > 0;
    }

    ngOnInit(): void {
        this.subscriptions$.add(this.invitesTrial$.pipe(tap(() => this.changeDetectorRef.detectChanges())).subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
